var render = function render(){var _vm=this,_c=_vm._self._c;return _c('body',{staticClass:"sidebar-mini sidebar-collapse",class:_vm.skin,staticStyle:{"height":"100%"}},[_c('div',{attrs:{"id":"app"}},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }